export enum RouteList {
    HOMEPAGE = '/',
    ARTISTS = 'artists',
    EDIT_ARTISTS = 'edit-artists',
    SIMULATION = 'simulation',
    EDIT_CREDENTIAL= 'edit-credentials'
}
